import stickersJson from '@/../public/stickers/stickers.json';
import dataJson from '@/../public/stickers/data.json';

export interface Sticker {
  name: string;
  text: string;
}

export interface StickerData {
  filename: string;
  width: number;
  height: number;
}

export const stickers: Sticker[] = stickersJson;
export const stickersData: StickerData[] = dataJson;
